export const columns = [
  { name: 'engineerName', title: 'Engineer Name' },
  { name: 'onsiteDTG', title: 'Onsite DTG', type: 'date' },
  { name: 'engineerDate', title: 'Engineer Date', type: 'date' },
  { name: 'repairerName', title: 'Repairer Name' },
  { name: 'postcode', title: 'Post Code' },
];

export const TOTAL_LOSS_REPORT = 'tlEngineeringScheduleReport';
export const TOTAL_LOSS_REPORT_TITLE = 'TL Engineering Schedule Report';
export const TOTAL_LOSS_REPORT_INFO = "Displays the forward schedule for the Total Loss Engineering team for the date range provided.";
